/**
 * THIS FILE IS GENERATED, DO NOT DIRECTLY EDIT
 */

import { PairResponse } from '@ui/services/backend/generated';
import { Address } from '@ui/types/alias';
import { ChainId } from '@ui/types/chain';

export const pairNamesByChain = {
  'Monad Testnet': [
    'XAG/USD',
    'SPY/USD',
    'LIT/USD',
    'SUI/USD',
    'HYPE/USD',
    'BTC/USD',
    'ETH/USD',
    'SOL/USD',
    'XRP/USD',
    'USD/JPY',
    'AAPL/USD',
    'USD/CNH',
    'TSM/USD',
    'META/USD',
    'EUR/USD',
    '500ETH/USD',
    '500BTC/USD',
    'XMR/USD',
    'LINK/USD',
    'AUD/USD',
    'NVDA/USD',
    'MSTR/USD',
    'MSFT/USD',
    'TSLA/USD',
    'MON/USD',
    'UNI/USD',
    'XAU/USD',
    'TRX/USD',
    'DOGE/USD',
    'ZEC/USD',
    'KPEPE/USD',
    'BNB/USD',
    'ADA/USD',
    'AMZN/USD',
    'GOOG/USD',
    'XPD/USD',
    'XPT/USD',
    'QQQ/USD',
    'AMD/USD',
    'NFLX/USD',
    'CRCL/USD',
  ] as const,
} as { [chainName: string]: readonly string[] };
export const allTradePairNames = [
  'XAG/USD',
  'SPY/USD',
  'LIT/USD',
  'SUI/USD',
  'HYPE/USD',
  'BTC/USD',
  'ETH/USD',
  'SOL/USD',
  'XRP/USD',
  'USD/JPY',
  'AAPL/USD',
  'USD/CNH',
  'TSM/USD',
  'META/USD',
  'EUR/USD',
  '500ETH/USD',
  '500BTC/USD',
  'XMR/USD',
  'LINK/USD',
  'AUD/USD',
  'NVDA/USD',
  'MSTR/USD',
  'MSFT/USD',
  'TSLA/USD',
  'MON/USD',
  'UNI/USD',
  'XAU/USD',
  'TRX/USD',
  'DOGE/USD',
  'ZEC/USD',
  'KPEPE/USD',
  'BNB/USD',
  'ADA/USD',
  'AMZN/USD',
  'GOOG/USD',
  'XPD/USD',
  'XPT/USD',
  'QQQ/USD',
  'AMD/USD',
  'NFLX/USD',
  'CRCL/USD',
] as const;
export type PairName = (typeof allTradePairNames)[number];

export const baseSymbolsByChain = {
  'Monad Testnet': [
    'XAG',
    'SPY',
    'LIT',
    'SUI',
    'HYPE',
    'BTC',
    'ETH',
    'SOL',
    'XRP',
    'JPY',
    'AAPL',
    'CNH',
    'TSM',
    'META',
    'EUR',
    'XMR',
    'LINK',
    'AUD',
    'NVDA',
    'MSTR',
    'MSFT',
    'TSLA',
    'MON',
    'UNI',
    'XAU',
    'TRX',
    'DOGE',
    'ZEC',
    'KPEPE',
    'BNB',
    'ADA',
    'AMZN',
    'GOOG',
    'XPD',
    'XPT',
    'QQQ',
    'AMD',
    'NFLX',
    'CRCL',
  ] as const,
};
export const allBaseSymbols = [
  'XAG',
  'SPY',
  'LIT',
  'SUI',
  'HYPE',
  'BTC',
  'ETH',
  'SOL',
  'XRP',
  'JPY',
  'AAPL',
  'CNH',
  'TSM',
  'META',
  'EUR',
  'XMR',
  'LINK',
  'AUD',
  'NVDA',
  'MSTR',
  'MSFT',
  'TSLA',
  'MON',
  'UNI',
  'XAU',
  'TRX',
  'DOGE',
  'ZEC',
  'KPEPE',
  'BNB',
  'ADA',
  'AMZN',
  'GOOG',
  'XPD',
  'XPT',
  'QQQ',
  'AMD',
  'NFLX',
  'CRCL',
] as const;
export type BaseSymbol = (typeof allBaseSymbols)[number];

export const basePairNamesByChain = {
  'Monad Testnet': [
    'XAG/USD',
    'SPY/USD',
    'LIT/USD',
    'SUI/USD',
    'HYPE/USD',
    'BTC/USD',
    'ETH/USD',
    'SOL/USD',
    'XRP/USD',
    'USD/JPY',
    'AAPL/USD',
    'USD/CNH',
    'TSM/USD',
    'META/USD',
    'EUR/USD',
    '500ETH/USD',
    '500BTC/USD',
    'XMR/USD',
    'LINK/USD',
    'AUD/USD',
    'NVDA/USD',
    'MSTR/USD',
    'MSFT/USD',
    'TSLA/USD',
    'MON/USD',
    'UNI/USD',
    'XAU/USD',
    'TRX/USD',
    'DOGE/USD',
    'ZEC/USD',
    'KPEPE/USD',
    'BNB/USD',
    'ADA/USD',
    'AMZN/USD',
    'GOOG/USD',
    'XPD/USD',
    'XPT/USD',
    'QQQ/USD',
    'AMD/USD',
    'NFLX/USD',
    'CRCL/USD',
  ] as const,
};
export const allBasePairNames = [
  'XAG/USD',
  'SPY/USD',
  'LIT/USD',
  'SUI/USD',
  'HYPE/USD',
  'BTC/USD',
  'ETH/USD',
  'SOL/USD',
  'XRP/USD',
  'USD/JPY',
  'AAPL/USD',
  'USD/CNH',
  'TSM/USD',
  'META/USD',
  'EUR/USD',
  '500ETH/USD',
  '500BTC/USD',
  'XMR/USD',
  'LINK/USD',
  'AUD/USD',
  'NVDA/USD',
  'MSTR/USD',
  'MSFT/USD',
  'TSLA/USD',
  'MON/USD',
  'UNI/USD',
  'XAU/USD',
  'TRX/USD',
  'DOGE/USD',
  'ZEC/USD',
  'KPEPE/USD',
  'BNB/USD',
  'ADA/USD',
  'AMZN/USD',
  'GOOG/USD',
  'XPD/USD',
  'XPT/USD',
  'QQQ/USD',
  'AMD/USD',
  'NFLX/USD',
  'CRCL/USD',
] as const;
export type BasePairName = (typeof allBasePairNames)[number];

export const allTags = [
  'COMMODITIES',
  'INDICES',
  'CRYPTO',
  'FOREX',
  'STOCKS',
  null,
] as const;
export type Tag = (typeof allTags)[number];

export const trade_pair_listings = {
  10143: [
    {
      base: '0x5ccc5c04130d272bf07d6e066f4cae40cfc03136',
      pairName: 'XAG/USD',
      symbol: 'XAG',
      pairType: 'COMMODITIES',
      isDegenPair: false,
      tags: ['COMMODITIES'],
      listAt: '2025-12-22T13:44:56.194772Z',
      nextOpen: '2026-07-16T22:00:00Z',
      nextClose: '2026-07-16T21:00:00Z',
      schedule:
        'America/New_York;0000-1700&1800-2400,0000-1700&1800-2400,0000-1700&1800-2400,0000-1700&1800-2400,0000-1700,C,1800-2400;0216/0000-1430&1800-2400,0402/0000-1700,0403/C,0525/0000-1430&1800-2400,0619/0000-1300,0703/0000-1300',
      priceDisplayDecimals: 4,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        'f2fb02c32b055c805e7238d628e5e9dadef274376114eb1f012337cabe93871e',
      pythSymbol: 'Metal.XAG/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0xcb8900160bd4a86d3b80f5ad5a44ee15823b0592',
      pairName: 'SPY/USD',
      symbol: 'SPY',
      pairType: 'INDICES',
      isDegenPair: false,
      tags: ['INDICES'],
      listAt: '2025-12-22T13:44:56.283357Z',
      nextOpen: '2026-07-17T13:30:00Z',
      nextClose: '2026-07-16T20:00:00Z',
      schedule:
        'America/New_York;0930-1600,0930-1600,0930-1600,0930-1600,0930-1600,C,C;0101/C,0119/C,0216/C,0403/C,0525/C,0619/C,0703/C',
      priceDisplayDecimals: 4,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        '19e09bb805456ada3979a7d1cbb4b6d63babc3a0f8e8a9509f68afa5c4c11cd5',
      pythSymbol: 'Equity.US.SPY/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0x232ce3bd40fcd6f80f3d55a522d03f25df784ee2',
      pairName: 'LIT/USD',
      symbol: 'LIT',
      pairType: 'CRYPTO',
      isDegenPair: false,
      tags: ['CRYPTO'],
      listAt: '2026-01-19T03:00:01.074729Z',
      schedule: 'America/New_York;O,O,O,O,O,O,O;',
      priceDisplayDecimals: 4,
      status: 'AVAILABLE',
      minHoldingSeconds: 180,
      holdingTimeThresholdSizeUSD: '40000000000000000000000',
      pythPriceFeedId:
        'c0c83f00c39165892d55dcd17ade2191e289697e2ac132d9ab721e20834e2a9e',
      pythSymbol: 'Crypto.LIT/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0x6df098ac2087ddd7401a9a9f19e0d60d4f07bb17',
      pairName: 'SUI/USD',
      symbol: 'SUI',
      pairType: 'CRYPTO',
      isDegenPair: false,
      tags: ['CRYPTO'],
      listAt: '2026-01-22T07:43:43.055416Z',
      schedule: 'America/New_York;O,O,O,O,O,O,O;',
      priceDisplayDecimals: 4,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        '23d7315113f5b1d3ba7a83604c44b94d79f4fd69af77f804fc7f920a6dc65744',
      pythSymbol: 'Crypto.SUI/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0xc5f3d8462b1cf323f17cd65568a8349b94a47e41',
      pairName: 'HYPE/USD',
      symbol: 'HYPE',
      pairType: 'CRYPTO',
      isDegenPair: false,
      tags: ['CRYPTO'],
      listAt: '2026-01-22T07:43:43.154468Z',
      schedule: 'America/New_York;O,O,O,O,O,O,O;',
      priceDisplayDecimals: 3,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        '4279e31cc369bbcc2faf022b382b080e32a8e689ff20fbc530d2a603eb6cd98b',
      pythSymbol: 'Crypto.HYPE/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0xcf5a6076cfa32686c0df13abada2b40dec133f1d',
      pairName: 'BTC/USD',
      symbol: 'BTC',
      pairType: 'CRYPTO',
      isDegenPair: false,
      tags: ['CRYPTO'],
      listAt: '2025-12-22T13:44:55.886328Z',
      schedule: 'America/New_York;O,O,O,O,O,O,O;',
      priceDisplayDecimals: 2,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        'e62df6c8b4a85fe1a67db44dc12de5db330f7ac66b72dc658afedf0f4a415b43',
      pythSymbol: 'Crypto.BTC/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0xb5a30b0fdc5ea94a52fdc42e3e9760cb8449fb37',
      pairName: 'ETH/USD',
      symbol: 'ETH',
      pairType: 'CRYPTO',
      isDegenPair: false,
      tags: ['CRYPTO'],
      listAt: '2025-12-22T13:44:55.993613Z',
      schedule: 'America/New_York;O,O,O,O,O,O,O;',
      priceDisplayDecimals: 2,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        'ff61491a931112ddf1bd8147cd1b641375f79f5825126d665480874634fd0ace',
      pythSymbol: 'Crypto.ETH/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0x0a3ec4fc70eaf64faf6eeda4e9b2bd4742a78546',
      pairName: 'SOL/USD',
      symbol: 'SOL',
      pairType: 'CRYPTO',
      isDegenPair: false,
      tags: ['CRYPTO'],
      listAt: '2025-12-22T13:44:55.997289Z',
      schedule: 'America/New_York;O,O,O,O,O,O,O;',
      priceDisplayDecimals: 3,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        'ef0d8b6fda2ceba41da15d4095d1da392a0d2f8ed0c6c7bc0f4cfac8c280b56d',
      pythSymbol: 'Crypto.SOL/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0xaeb724422620edb430dcaf22aeeff2e9388a578c',
      pairName: 'XRP/USD',
      symbol: 'XRP',
      pairType: 'CRYPTO',
      isDegenPair: false,
      tags: ['CRYPTO'],
      listAt: '2025-12-22T13:44:56.03844Z',
      schedule: 'America/New_York;O,O,O,O,O,O,O;',
      priceDisplayDecimals: 4,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        'ec5d399846a9209f3fe5881d70aae9268c94339ff9817e8d18ff19fa05eea1c8',
      pythSymbol: 'Crypto.XRP/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0x35b8bafff3570683af968b8d36b91b1a19465141',
      pairName: 'USD/JPY',
      symbol: 'JPY',
      pairType: 'FOREX',
      isDegenPair: false,
      tags: ['FOREX'],
      listAt: '2025-12-22T13:44:56.289352Z',
      nextOpen: '2026-07-19T21:00:00Z',
      nextClose: '2026-07-17T21:00:00Z',
      schedule:
        'America/New_York;O,O,O,O,0000-1700,C,1700-2400;1224/0000-1700,1231/0000-1700',
      priceDisplayDecimals: 4,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        'ef2c98c804ba503c6a707e38be4dfbb16683775f195b091252bf24693042fd52',
      pythSymbol: 'FX.USD/JPY',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0x3a54a9a690616fbc26cfc409bf11f89d51f1d57a',
      pairName: 'AAPL/USD',
      symbol: 'AAPL',
      pairType: 'STOCKS',
      isDegenPair: false,
      tags: ['STOCKS'],
      listAt: '2025-12-22T13:44:56.090902Z',
      nextOpen: '2026-07-17T13:30:00Z',
      nextClose: '2026-07-16T20:00:00Z',
      schedule:
        'America/New_York;0930-1600,0930-1600,0930-1600,0930-1600,0930-1600,C,C;0101/C,0119/C,0216/C,0403/C,0525/C,0619/C,0703/C',
      priceDisplayDecimals: 2,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        '49f6b65cb1de6b10eaf75e7c03ca029c306d0357e91b5311b175084a5ad55688',
      pythSymbol: 'Equity.US.AAPL/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0x54b8e78c6c147de36b4914b070365df449151317',
      pairName: 'USD/CNH',
      symbol: 'CNH',
      pairType: 'FOREX',
      isDegenPair: false,
      tags: ['FOREX'],
      listAt: '2026-01-22T07:43:43.659409Z',
      nextOpen: '2026-07-16T22:00:00Z',
      nextClose: '2026-07-16T21:00:00Z',
      schedule:
        'America/New_York;0000-1700&1800-2400,0000-1700&1800-2400,0000-1700&1800-2400,0000-1700&1800-2400,0000-1700,C,1800-2400;1224/0000-1700,1231/0000-1700',
      priceDisplayDecimals: 4,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        'eef52e09c878ad41f6a81803e3640fe04dceea727de894edd4ea117e2e332e66',
      pythSymbol: 'FX.USD/CNH',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0xad1fa1fdcf0d5e63722d43fb25f8ed3d51d3c074',
      pairName: 'TSM/USD',
      symbol: 'TSM',
      pairType: 'STOCKS',
      isDegenPair: false,
      tags: ['STOCKS'],
      listAt: '2026-05-26T10:20:01.948195Z',
      nextOpen: '2026-07-17T13:30:00Z',
      nextClose: '2026-07-16T20:00:00Z',
      schedule:
        'America/New_York;0930-1600,0930-1600,0930-1600,0930-1600,0930-1600,C,C;0101/C,0119/C,0216/C,0403/C,0525/C,0619/C,0703/C',
      priceDisplayDecimals: 2,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        'e722560a66e4ab00522ef20a38fa2ba5d1b41f1c5404723ed895d202a7af7cc4',
      pythSymbol: 'Equity.US.TSM/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0x0057355892fab25ddc63a7482ec1696d6ada6703',
      pairName: 'META/USD',
      symbol: 'META',
      pairType: 'STOCKS',
      isDegenPair: false,
      tags: ['STOCKS'],
      listAt: '2025-12-22T13:44:56.188926Z',
      nextOpen: '2026-07-17T13:30:00Z',
      nextClose: '2026-07-16T20:00:00Z',
      schedule:
        'America/New_York;0930-1600,0930-1600,0930-1600,0930-1600,0930-1600,C,C;0101/C,0119/C,0216/C,0403/C,0525/C,0619/C,0703/C',
      priceDisplayDecimals: 4,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        '78a3e3b8e676a8f73c439f5d749737034b139bbbe899ba5775216fba596607fe',
      pythSymbol: 'Equity.US.META/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0xa9226449042e36bf6865099eec57482aa55e3ad0',
      pairName: 'EUR/USD',
      symbol: 'EUR',
      pairType: 'FOREX',
      isDegenPair: false,
      tags: ['FOREX'],
      listAt: '2025-12-22T13:44:56.286578Z',
      nextOpen: '2026-07-19T21:00:00Z',
      nextClose: '2026-07-17T21:00:00Z',
      schedule:
        'America/New_York;O,O,O,O,0000-1700,C,1700-2400;1224/0000-1700,1231/0000-1700',
      priceDisplayDecimals: 4,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        'a995d00bb36a63cef7fd2c287dc105fc8f3d93779f062f09551b0af3e81ec30b',
      pythSymbol: 'FX.EUR/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0x0000000000000000000000000000000000000004',
      pairName: '500ETH/USD',
      symbol: 'ETH',
      pairType: 'CRYPTO',
      isDegenPair: true,
      tags: ['CRYPTO'],
      listAt: '2025-12-22T13:44:56.087857Z',
      schedule: 'America/New_York;O,O,O,O,O,O,O;',
      priceDisplayDecimals: 2,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        'ff61491a931112ddf1bd8147cd1b641375f79f5825126d665480874634fd0ace',
      pythSymbol: 'Crypto.ETH/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0x0000000000000000000000000000000000000003',
      pairName: '500BTC/USD',
      symbol: 'BTC',
      pairType: 'CRYPTO',
      isDegenPair: true,
      tags: ['CRYPTO'],
      listAt: '2025-12-22T13:44:56.084591Z',
      schedule: 'America/New_York;O,O,O,O,O,O,O;',
      priceDisplayDecimals: 2,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        'e62df6c8b4a85fe1a67db44dc12de5db330f7ac66b72dc658afedf0f4a415b43',
      pythSymbol: 'Crypto.BTC/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0xa5e34d2f9b8f4a05d531b5cc03e06624285b7a00',
      pairName: 'XMR/USD',
      symbol: 'XMR',
      pairType: 'CRYPTO',
      isDegenPair: false,
      tags: ['CRYPTO'],
      listAt: '2026-01-19T03:08:26.422881Z',
      schedule: 'America/New_York;O,O,O,O,O,O,O;',
      priceDisplayDecimals: 2,
      status: 'AVAILABLE',
      minHoldingSeconds: 180,
      holdingTimeThresholdSizeUSD: '40000000000000000000000',
      pythPriceFeedId:
        '46b8cc9347f04391764a0361e0b17c3ba394b001e7c304f7650f6376e37c321d',
      pythSymbol: 'Crypto.XMR/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0x062e57bcf79ec1579df888e32a3f07cc899dc60a',
      pairName: 'LINK/USD',
      symbol: 'LINK',
      pairType: 'CRYPTO',
      isDegenPair: false,
      tags: ['CRYPTO'],
      listAt: '2026-01-22T07:43:43.212163Z',
      schedule: 'America/New_York;O,O,O,O,O,O,O;',
      priceDisplayDecimals: 3,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        '8ac0c70fff57e9aefdf5edf44b51d62c2d433653cbb2cf5cc06bb115af04d221',
      pythSymbol: 'Crypto.LINK/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0xf4940d379cdb765b9e0430725c0c9efb14a767ce',
      pairName: 'AUD/USD',
      symbol: 'AUD',
      pairType: 'FOREX',
      isDegenPair: false,
      tags: ['FOREX'],
      listAt: '2026-01-22T07:43:43.310787Z',
      nextOpen: '2026-07-19T21:00:00Z',
      nextClose: '2026-07-17T21:00:00Z',
      schedule:
        'America/New_York;O,O,O,O,0000-1700,C,1700-2400;1224/0000-1700,1231/0000-1700',
      priceDisplayDecimals: 4,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        '67a6f93030420c1c9e3fe37c1ab6b77966af82f995944a9fefce357a22854a80',
      pythSymbol: 'FX.AUD/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0xe108948b9667048232851f26a1427d3a908b22da',
      pairName: 'NVDA/USD',
      symbol: 'NVDA',
      pairType: 'STOCKS',
      isDegenPair: false,
      tags: ['STOCKS'],
      listAt: '2025-12-22T13:44:56.18595Z',
      nextOpen: '2026-07-17T13:30:00Z',
      nextClose: '2026-07-16T20:00:00Z',
      schedule:
        'America/New_York;0930-1600,0930-1600,0930-1600,0930-1600,0930-1600,C,C;0101/C,0119/C,0216/C,0403/C,0525/C,0619/C,0703/C',
      priceDisplayDecimals: 4,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        'b1073854ed24cbc755dc527418f52b7d271f6cc967bbf8d8129112b18860a593',
      pythSymbol: 'Equity.US.NVDA/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0x3ae04eab3c283c5516c3958271264ba9dbafcb4e',
      pairName: 'MSTR/USD',
      symbol: 'MSTR',
      pairType: 'STOCKS',
      isDegenPair: false,
      tags: ['STOCKS'],
      listAt: '2026-01-22T07:43:43.959851Z',
      nextOpen: '2026-07-17T13:30:00Z',
      nextClose: '2026-07-16T20:00:00Z',
      schedule:
        'America/New_York;0930-1600,0930-1600,0930-1600,0930-1600,0930-1600,C,C;0101/C,0119/C,0216/C,0403/C,0525/C,0619/C,0703/C',
      priceDisplayDecimals: 3,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        'e1e80251e5f5184f2195008382538e847fafc36f751896889dd3d1b1f6111f09',
      pythSymbol: 'Equity.US.MSTR/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0xb2023082f01404dd0ce6937cab03c4f5d6db9ba8',
      pairName: 'MSFT/USD',
      symbol: 'MSFT',
      pairType: 'STOCKS',
      isDegenPair: false,
      tags: ['STOCKS'],
      listAt: '2025-12-22T13:44:56.138165Z',
      nextOpen: '2026-07-17T13:30:00Z',
      nextClose: '2026-07-16T20:00:00Z',
      schedule:
        'America/New_York;0930-1600,0930-1600,0930-1600,0930-1600,0930-1600,C,C;0101/C,0119/C,0216/C,0403/C,0525/C,0619/C,0703/C',
      priceDisplayDecimals: 4,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        'd0ca23c1cc005e004ccf1db5bf76aeb6a49218f43dac3d4b275e92de12ded4d1',
      pythSymbol: 'Equity.US.MSFT/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0x0a8f1f385fed9c77a2e0daa363ccc865e971bdbe',
      pairName: 'TSLA/USD',
      symbol: 'TSLA',
      pairType: 'STOCKS',
      isDegenPair: false,
      tags: ['STOCKS'],
      listAt: '2025-12-22T13:44:56.182548Z',
      nextOpen: '2026-07-17T13:30:00Z',
      nextClose: '2026-07-16T20:00:00Z',
      schedule:
        'America/New_York;0930-1600,0930-1600,0930-1600,0930-1600,0930-1600,C,C;0101/C,0119/C,0216/C,0403/C,0525/C,0619/C,0703/C',
      priceDisplayDecimals: 4,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        '16dad506d7db8da01c87581c87ca897a012a153557d4d578c3b9c9e1bc0632f1',
      pythSymbol: 'Equity.US.TSLA/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0x3bd359c1119da7da1d913d1c4d2b7c461115433a',
      pairName: 'MON/USD',
      symbol: 'MON',
      pairType: 'CRYPTO',
      isDegenPair: false,
      tags: ['CRYPTO'],
      listAt: '2025-12-23T09:18:12.594159Z',
      schedule: 'America/New_York;O,O,O,O,O,O,O;',
      priceDisplayDecimals: 5,
      status: 'AVAILABLE',
      minHoldingSeconds: 180,
      holdingTimeThresholdSizeUSD: '40000000000000000000000',
      pythPriceFeedId:
        '31491744e2dbf6df7fcf4ac0820d18a609b49076d45066d3568424e62f686cd1',
      pythSymbol: 'Crypto.MON/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0x1f9840a85d5af5bf1d1762f925bdaddc4201f984',
      pairName: 'UNI/USD',
      symbol: 'UNI',
      pairType: 'CRYPTO',
      isDegenPair: false,
      tags: ['CRYPTO'],
      listAt: '2026-01-07T11:31:43.746437Z',
      schedule: 'America/New_York;O,O,O,O,O,O,O;',
      priceDisplayDecimals: 4,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        '78d185a741d07edb3412b09008b7c5cfb9bbbd7d568bf00ba737b456ba171501',
      pythSymbol: 'Crypto.UNI/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0x7c687a3207cd9c05b4b11d8dd7ac337919c22001',
      pairName: 'XAU/USD',
      symbol: 'XAU',
      pairType: 'COMMODITIES',
      isDegenPair: false,
      tags: ['COMMODITIES'],
      listAt: '2025-12-22T13:44:56.191637Z',
      nextOpen: '2026-07-16T22:00:00Z',
      nextClose: '2026-07-16T21:00:00Z',
      schedule:
        'America/New_York;0000-1700&1800-2400,0000-1700&1800-2400,0000-1700&1800-2400,0000-1700&1800-2400,0000-1700,C,1800-2400;0216/0000-1430&1800-2400,0402/0000-1700,0403/C,0525/0000-1430&1800-2400,0619/0000-1300,0703/0000-1300',
      priceDisplayDecimals: 4,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        '765d2ba906dbc32ca17cc11f5310a89e9ee1f6420508c63861f2f8ba4ee34bb2',
      pythSymbol: 'Metal.XAU/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0x601e2aa61d4354b3e5dbcb86733bac211c073a4e',
      pairName: 'TRX/USD',
      symbol: 'TRX',
      pairType: 'CRYPTO',
      isDegenPair: false,
      tags: ['CRYPTO'],
      listAt: '2026-06-13T06:56:12.88164Z',
      schedule: 'America/New_York;O,O,O,O,O,O,O;',
      priceDisplayDecimals: 4,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        '0x0000000000000000000000000000000000000000000000000000000000000011',
      pythSymbol: 'Crypto.TRX/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0xba2ae424d960c26247dd6c32edc70b295c744c43',
      pairName: 'DOGE/USD',
      symbol: 'DOGE',
      pairType: 'CRYPTO',
      isDegenPair: false,
      tags: ['CRYPTO'],
      listAt: '2026-01-07T11:31:43.838443Z',
      schedule: 'America/New_York;O,O,O,O,O,O,O;',
      priceDisplayDecimals: 4,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        'dcef50dd0a4cd2dcc17e45df1676dcb336a11a61c69df7a0299b0150c672d25c',
      pythSymbol: 'Crypto.DOGE/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0x1ba42e5193dfa8b03d15dd1b86a3113bbbef8eeb',
      pairName: 'ZEC/USD',
      symbol: 'ZEC',
      pairType: 'CRYPTO',
      isDegenPair: false,
      tags: ['CRYPTO'],
      listAt: '2026-01-07T11:31:43.84386Z',
      schedule: 'America/New_York;O,O,O,O,O,O,O;',
      priceDisplayDecimals: 2,
      status: 'AVAILABLE',
      minHoldingSeconds: 180,
      holdingTimeThresholdSizeUSD: '40000000000000000000000',
      pythPriceFeedId:
        'be9b59d178f0d6a97ab4c343bff2aa69caa1eaae3e9048a65788c529b125bb24',
      pythSymbol: 'Crypto.ZEC/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0x721d0151ac1740353c14798db0c464b8c0116cc3',
      pairName: 'KPEPE/USD',
      symbol: 'KPEPE',
      pairType: 'CRYPTO',
      isDegenPair: false,
      tags: ['CRYPTO'],
      listAt: '2026-01-07T12:13:34.037061Z',
      schedule: 'America/New_York;O,O,O,O,O,O,O;',
      priceDisplayDecimals: 4,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        '7f3febb69d47fd18c6e29697fc2c19ee70b9877111410238d8587f2cffacb232',
      pythSymbol: 'Crypto.KPEPE/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0x160a9630e8b9343f7fccdecf67bf1a59fe8d2b58',
      pairName: 'BNB/USD',
      symbol: 'BNB',
      pairType: 'CRYPTO',
      isDegenPair: false,
      tags: ['CRYPTO'],
      listAt: '2026-06-13T06:56:11.986758Z',
      schedule: 'America/New_York;O,O,O,O,O,O,O;',
      priceDisplayDecimals: 4,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        '0x000000000000000000000000000000000000000000000000000000000000000f',
      pythSymbol: 'Crypto.BNB/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0xe9d95d048d2a009f6286570e4ad419dbba8490ef',
      pairName: 'ADA/USD',
      symbol: 'ADA',
      pairType: 'CRYPTO',
      isDegenPair: false,
      tags: ['CRYPTO'],
      listAt: '2026-01-22T07:43:42.855796Z',
      schedule: 'America/New_York;O,O,O,O,O,O,O;',
      priceDisplayDecimals: 5,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        '2a01deaec9e51a579277b34b122399984d0bbf57e2458a7e42fecd2829867a0d',
      pythSymbol: 'Crypto.ADA/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0x6c755094f1cdd95e2e4170549dc12e7555151536',
      pairName: 'AMZN/USD',
      symbol: 'AMZN',
      pairType: 'STOCKS',
      isDegenPair: false,
      tags: ['STOCKS'],
      listAt: '2025-12-22T13:44:56.094415Z',
      nextOpen: '2026-07-17T13:30:00Z',
      nextClose: '2026-07-16T20:00:00Z',
      schedule:
        'America/New_York;0930-1600,0930-1600,0930-1600,0930-1600,0930-1600,C,C;0101/C,0119/C,0216/C,0403/C,0525/C,0619/C,0703/C',
      priceDisplayDecimals: 4,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        'b5d0e0fa58a1f8b81498ae670ce93c872d14434b72c364885d4fa1b257cbb07a',
      pythSymbol: 'Equity.US.AMZN/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0x9a4f772de1a5f6df5913fa2c98dd7177eaa23dc2',
      pairName: 'GOOG/USD',
      symbol: 'GOOG',
      pairType: 'STOCKS',
      isDegenPair: false,
      tags: ['STOCKS'],
      listAt: '2025-12-22T13:44:56.141197Z',
      nextOpen: '2026-07-17T13:30:00Z',
      nextClose: '2026-07-16T20:00:00Z',
      schedule:
        'America/New_York;0930-1600,0930-1600,0930-1600,0930-1600,0930-1600,C,C;0101/C,0119/C,0216/C,0403/C,0525/C,0619/C,0703/C',
      priceDisplayDecimals: 4,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        'e65ff435be42630439c96396653a342829e877e2aafaeaf1a10d0ee5fd2cf3f2',
      pythSymbol: 'Equity.US.GOOG/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0xe426fb9717f3813cc76a3271587d9bec13875f8d',
      pairName: 'XPD/USD',
      symbol: 'XPD',
      pairType: 'COMMODITIES',
      isDegenPair: false,
      tags: ['COMMODITIES'],
      listAt: '2026-01-22T07:43:44.714444Z',
      nextOpen: '2026-07-16T22:00:00Z',
      nextClose: '2026-07-16T21:00:00Z',
      schedule:
        'America/New_York;0000-1700&1800-2400,0000-1700&1800-2400,0000-1700&1800-2400,0000-1700&1800-2400,0000-1700,C,1800-2400;0525/0000-1430&1800-2400,0525/0000-1430&1800-2400,0619/0000-1300,0703/0000-1300',
      priceDisplayDecimals: 4,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        '80367e9664197f37d89a07a804dffd2101c479c7c4e8490501bc9d9e1e7f9021',
      pythSymbol: 'Metal.XPD/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0xc88cc73c99870bba0314f459398b92ca9bdc5dd6',
      pairName: 'XPT/USD',
      symbol: 'XPT',
      pairType: 'COMMODITIES',
      isDegenPair: false,
      tags: ['COMMODITIES'],
      listAt: '2026-01-22T07:43:44.610135Z',
      nextOpen: '2026-07-16T22:00:00Z',
      nextClose: '2026-07-16T21:00:00Z',
      schedule:
        'America/New_York;0000-1700&1800-2400,0000-1700&1800-2400,0000-1700&1800-2400,0000-1700&1800-2400,0000-1700,C,1800-2400;0216/0000-1430&1800-2400,0402/0000-1700,0403/C,0525/0000-1430&1800-2400,0619/0000-1300,0703/0000-1300',
      priceDisplayDecimals: 2,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        '398e4bbc7cbf89d6648c21e08019d878967677753b3096799595c78f805a34e5',
      pythSymbol: 'Metal.XPT/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0xb589511c51d1ffda5d943ac1c9733e112abeff7b',
      pairName: 'QQQ/USD',
      symbol: 'QQQ',
      pairType: 'INDICES',
      isDegenPair: false,
      tags: ['INDICES'],
      listAt: '2025-12-22T13:44:56.236741Z',
      nextOpen: '2026-07-17T13:30:00Z',
      nextClose: '2026-07-16T20:00:00Z',
      schedule:
        'America/New_York;0930-1600,0930-1600,0930-1600,0930-1600,0930-1600,C,C;0101/C,0119/C,0216/C,0403/C,0525/C,0619/C,0703/C',
      priceDisplayDecimals: 4,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        '9695e2b96ea7b3859da9ed25b7a46a920a776e2fdae19a7bcfdf2b219230452d',
      pythSymbol: 'Equity.US.QQQ/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0x673187b2142ef3cff8a77799a3f207126ff02c55',
      pairName: 'AMD/USD',
      symbol: 'AMD',
      pairType: 'STOCKS',
      isDegenPair: false,
      tags: ['STOCKS'],
      listAt: '2026-01-22T07:43:44.40849Z',
      nextOpen: '2026-07-17T13:30:00Z',
      nextClose: '2026-07-16T20:00:00Z',
      schedule:
        'America/New_York;0930-1600,0930-1600,0930-1600,0930-1600,0930-1600,C,C;0101/C,0119/C,0216/C,0403/C,0525/C,0619/C,0703/C',
      priceDisplayDecimals: 3,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        '3622e381dbca2efd1859253763b1adc63f7f9abb8e76da1aa8e638a57ccde93e',
      pythSymbol: 'Equity.US.AMD/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0x3d9fd1a881e7e0c02c76071f9e565d22a300cc73',
      pairName: 'NFLX/USD',
      symbol: 'NFLX',
      pairType: 'STOCKS',
      isDegenPair: false,
      tags: ['STOCKS'],
      listAt: '2026-01-22T07:43:44.162419Z',
      nextOpen: '2026-07-17T13:30:00Z',
      nextClose: '2026-07-16T20:00:00Z',
      schedule:
        'America/New_York;0930-1600,0930-1600,0930-1600,0930-1600,0930-1600,C,C;0101/C,0119/C,0216/C,0403/C,0525/C,0619/C,0703/C',
      priceDisplayDecimals: 4,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        '8376cfd7ca8bcdf372ced05307b24dced1f15b1afafdeff715664598f15a3dd2',
      pythSymbol: 'Equity.US.NFLX/USD',
      volume: '0',
      volumeUSD: '0',
    },
    {
      base: '0xdf104b3ddf24cece9843178ccc86a2152b3a4e07',
      pairName: 'CRCL/USD',
      symbol: 'CRCL',
      pairType: 'STOCKS',
      isDegenPair: false,
      tags: ['STOCKS'],
      listAt: '2026-01-22T07:43:44.058065Z',
      nextOpen: '2026-07-17T13:30:00Z',
      nextClose: '2026-07-16T20:00:00Z',
      schedule:
        'America/New_York;0930-1600,0930-1600,0930-1600,0930-1600,0930-1600,C,C;0101/C,0119/C,0216/C,0403/C,0525/C,0619/C,0703/C',
      priceDisplayDecimals: 4,
      status: 'AVAILABLE',
      minHoldingSeconds: 0,
      holdingTimeThresholdSizeUSD: '0',
      pythPriceFeedId:
        '92b8527aabe59ea2b12230f7b532769b133ffb118dfbd48ff676f14b273f1365',
      pythSymbol: 'Equity.US.CRCL/USD',
      volume: '0',
      volumeUSD: '0',
    },
  ],
} as unknown as Record<ChainId, PairResponse[]>;
